











































import { Component, Prop, Vue } from 'vue-property-decorator';
import Equation from '@/components/Equation.vue';
import { TakeoffRunConstraint } from '@/interfaces/constraints';

@Component({
  components: {
  Equation,
  }
  })
export default class TakeoffRunFields extends Vue {
  @Prop() constraint!: TakeoffRunConstraint;
}
